import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";

export default function RechargeView({
  goBack,
  goToCard,
  goToPix,
}: PropsView) {
  
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="z-10 p-4 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Forma de pagamento</h2>
            <h3 className="text-black text-sm mt-2">Selecione abaixo como quer fazer o pagamento</h3>
            <button type="submit" onClick={goToCard} className="w-full flex justify-between items-center mt-5 text-start">
              <div className="flex items-center">
                <img 
                  src={"/icon-credit-card.png"}
                  width={40}
                  height={40}
                  alt="Card credit icon"
                />
                <div className="ml-3">
                  <p className="text-base">Cartão de crédito</p>
                  <p className="text-xs">Informações do seu cartão</p>
                </div>
              </div>
              <img 
                src={"/arrow-right.png"}
                width={24}
                height={24}
                alt="escolher cartão"
              />
            </button>
            <div className="w-full h-px bg-slate-300 mt-4 mb-4" />
            <button type="submit" onClick={goToPix} className="w-full flex flex justify-between items-center text-start">
              <div className="flex items-center">
                <img 
                  src={"/icon-pix.png"}
                  width={40}
                  height={40}
                  alt="pix icon"
                />
                <div className="ml-3">
                  <p className="text-base">Pix</p>
                  <p className="text-xs">Informações para pagamento</p>
                </div>
              </div>
              <img 
                src={"/arrow-right.png"}
                width={24}
                height={24}
                alt="escolher pix"
              />
            </button>
          </div>
        </article>
      </main>

    </div>
  );
}
